module.exports = __webpack_public_path__ + "static/media/whichThinnerDontMiss.bd9a010b.mp3";